import styled from 'styled-components'
import { colors } from '../../../styles'

export const StyledTableRow = styled.tr`
  z-index: 32;
  padding: 12px 8px;
  display: grid;
  grid-template-columns: 3fr 3fr 2fr 1fr 1fr;

  &:hover {
    background-color: ${colors.orange10};
    cursor: pointer;
  }
` as any

export const StyledAllGroupsTable = styled.table`
  width: 100%;
  tr {
    padding: 8px 8px;
    display: grid;
    grid-template-columns: 3fr 3fr 2fr 1fr 1fr;
  }
  td,
  th {
    word-break: break-word;
    text-align: left;
  }
  td {
    display: flex;
    align-items: center;
  }
`
